<template lang="pug">
  b-taginput(
    class="taginput-sortable"
    v-sortable="sortableOptions"
    v-model="newTags"
    :data="tag.filteredTags"
    autocomplete
    :allow-new="tag.allowNew"
    :open-on-focus="tag.openOnFocus"
    :aria-close-label="tag.ariaCloseLabel"
    :confirm-keys=[",", "Tab", "Enter"]
    icon="label-alt"
    size="is-medium"
    rounded
    maxlength=30
    placeholder="タグを追加する"
    @typing="getFilteredTags"
    @add="resetFilteredTags"
    @remove="resetFilteredTags")
</template>

<script>
import Sortable from 'sortablejs/modular/sortable.core.esm.js'

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
    onEnd: function (evt) {
      const data = vnode.context.$data.newTags
      const item = data[evt.oldIndex]
      if (evt.newIndex > evt.oldIndex) {
        for (let i = evt.oldIndex; i < evt.newIndex; i++) {
          data[i] = data[i + 1]
        }
      } else {
        for (let i = evt.oldIndex; i > evt.newIndex; i--) {
          data[i] = data[i - 1]
        }
      }
      data[evt.newIndex] = item
      vnode.context.$emit('input', data)
    }
  })
}

const sortable = {
    name: 'sortable',
    bind(el, binding, vnode) {
        const container = el.querySelector('.taginput-container')
        container._sortable = createSortable(container, binding.value, vnode)
    },
    update(el, binding, vnode) {
        const container = el.querySelector('.taginput-container')
        container._sortable.destroy()
        container._sortable = createSortable(container, binding.value, vnode)
    },
    unbind(el) {
        const container = el.querySelector('.taginput-container')
        container._sortable.destroy()
    }
}

export default {
  name: 'PostTagInput',
  directives: { sortable },
  data: function(){
    return {
      /* タグ */
      newTags: [],

      /* tag input settings */
      tag: {
        filteredTags: new Array(),
        isSelectOnly: false,
        allowNew: true,
        openOnFocus: false,
        allowDuplicates: false,
        ariaCloseLabel: 'タグを削除する'
      },

      /* SortableJS */
      sortableOptions: {
        chosenClass: 'is-primary',
        draggable: '.tag'
      }
    }
  },
  props: [
    'oldTags'
  ],
  watch: {
    'oldTags'(newArray) {
      this.newTags = newArray
    },
    'newTags'(newArray) {
      this.$emit('setNewTags', newArray)
    }
  },
  created() {
    this.getTagList()
  },
  methods: {
    async getTagList() {
      try {
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS
        )
        const r = res.data
        if( r.status == 1 ){
          const data = r.data
          const _tagList = data.map(item => item.name)
          this.tag.filteredTags = _tagList
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'タグ一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    resetFilteredTags() {
      this.getFilteredTags('')
    },
    async getFilteredTags(val) {
      try {
        let data_obj = {
          keyword: val
        }

        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS,
          { params: data_obj }
        )

        let r = res.data

        if( r.status == 1 ){
          const data = r.data

          this.tag.filteredTags = data.map( tag => tag.name )
          this.tag.filteredTags = this.tag.filteredTags.filter( tag => !this.newTags.includes(tag) )
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'タグ一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>

<style>
.taginput-sortable .tag {
  cursor: grab !important;
}
</style>